import React from 'react';
import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom'; // or any other routing library you use
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

import logo from '../media/ml-logo2.png'; // Adjust path as needed

const FooterContainer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 2rem;
  background-color: transparent; /* Dark background for contrast */
  color: #fff;
  font-family: 'Quicksand', sans-serif;
  text-align: center;

  @media(min-width: 768px) {
    text-align: left;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  width: 95%;
  

  > div {
    width: fit-content;
  }

  @media(min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    justify-content: start;
  }
`;

const Logo = styled.img`
  width: 200px;
  object-fit: contain;
  filter: grayscale(200%) invert(1) brightness(2);
`;

const SectionTitle = styled.h3`
  margin: 0;
  font-weight: 600;
  width: fit-content;
`;

const FooterLink = styled.a`
  color: #fff;
  text-decoration: none;
  transition: color 0.3s ease-in-out;
  width: fit-content;
  &:hover {
    color: #4a90e2;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
  width: 95%;

  > a > .MuiSvgIcon-root {
    color: #fff;
  text-decoration: none;
  transition: color 0.3s ease-in-out;
  &:hover {
    color: #4a90e2;
  }
  }
`;

const Copyright = styled.p`
  margin: 1rem 0 0;
  font-size: 0.875rem;
  opacity: 0.7;
  width: 95%;
  display: flex;
  align-items: center;
  gap: 10px;

  > span {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 20px;

    > span {
      cursor: pointer;
      transition: color 0.3s ease-in-out;

      &:hover {
        color: #f06;
      }
    }
  }
`;


const MCopyright = styled.p`
  margin: 1rem 0 0;
  font-size: 0.875rem;
  opacity: 0.7;
  width: 95%;
  display: flex;
  align-items: center;
  gap: 10px;
  display: flex;
  flex-direction: column;

  > div > span {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 20px;

    > span {
      cursor: pointer;
      transition: color 0.3s ease-in-out;

      &:hover {
        color: #f06;
      }
    }
  }
`;

const FooterLinkContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
`

export default function Footer({ sWidth }) {
  return (
    <FooterContainer>
      {sWidth > 768 && <FooterSection>
        <div>
          <Logo src={logo} alt="MarketLab Logo" />
        </div>
        <div style={{marginLeft: 'auto', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '260px'}}>
        <div style={{marginLeft: 'auto'}}>
          <SectionTitle>Market Lab</SectionTitle>
          <FooterLinkContainer>
          <FooterLink href="#features">Features</FooterLink>
          <FooterLink href="#pricing">Pricing</FooterLink>
          <FooterLink href="#faq">FAQs</FooterLink>
          </FooterLinkContainer>
        </div>
        <div style={{marginLeft: 'auto'}}>
          <FooterLinkContainer>
          <SectionTitle>Company</SectionTitle>
          <FooterLink href="https://improwth.com/about" target='_blank'>About Improwth</FooterLink>
          <FooterLink href="https://improwth.com/products" target='_blank'>Other Products by Improwth</FooterLink>
          <FooterLink href="https://improwth.com/contact" target='_blank'>Contact Improwth</FooterLink>
          </FooterLinkContainer>
        </div>
        </div>
      </FooterSection>}
      {sWidth <= 768 && <FooterSection>
        <div>
          <Logo src={logo} alt="MarketLab Logo" />
        </div>
        <div>
          <SectionTitle>Market Lab</SectionTitle>
          <FooterLinkContainer>
          <FooterLink href="#features">Features</FooterLink>
          <FooterLink href="#pricing">Pricing</FooterLink>
          <FooterLink href="#faq">FAQs</FooterLink>
          </FooterLinkContainer>
        </div>
        <div>
          <FooterLinkContainer>
          <SectionTitle>Company</SectionTitle>
          <FooterLink href="https://improwth.com/about" target='_blank'>About Improwth</FooterLink>
          <FooterLink href="https://improwth.com/products" target='_blank'>Other Products by Improwth</FooterLink>
          <FooterLink href="https://improwth.com/contact" target='_blank'>Contact Improwth</FooterLink>
          </FooterLinkContainer>
        </div>
      </FooterSection>}
      <SocialIcons>
        <a href="https://twitter.com/improwth" target="_blank" rel="noopener noreferrer">
          <XIcon color="#fff" size="1.5rem" />
        </a>
        <a href="https://www.linkedin.com/company/improwth/" target="_blank" rel="noopener noreferrer">
          <LinkedInIcon color="#fff" size="1.5rem" />
        </a>
      </SocialIcons>
      {sWidth > 768 && <Copyright>
        {'Copyright © '}
        <FooterLink href="https://improwth.com" target="_blank">Improwth</FooterLink>
        {` ${new Date().getFullYear()}`}
        <span><span  onClick={()=> window.open('/privacy-policy', '_blank')}>Privacy Policy</span><span  onClick={()=> window.open('/terms-of-use', '_blank')}>Terms of Service</span></span>
      </Copyright>}
      {sWidth <= 768 && <MCopyright>
        <div>
        {'Copyright © '}
        <FooterLink href="https://improwth.com" target="_blank">Improwth</FooterLink>
        {` ${new Date().getFullYear()}`}</div>
        <div><span><span  onClick={()=> window.open('/privacy-policy', '_blank')}>Privacy Policy</span><span  onClick={()=> window.open('/terms-of-use', '_blank')}>Terms of Service</span></span></div>
      </MCopyright>}
    </FooterContainer>
  );
}
